export const TAKE_A_BREAK_API_PATH_PREFIX = '/api/account/take-a-break'
export const TAKE_A_BREAK_ROUTE = 'account/take-a-break'
